const styles = (theme) => ({
  dataGrid: {
    border: `1px solid ${theme.AppBGColor}`,
    [`&>.gridTheme-${theme.themeName}>.ag-theme-material.theme-${theme.themeName}`]: {
      height: "100%",
    },
    "& .ag-theme-material .ag-icon-checkbox-checked": {
      color: theme.HeaderSelectedText,
    },
    "& .ag-theme-material .checkBoxHeader": {
      display: "flex",
      paddingLeft: 20,
    },
    [`& .gridTheme-${theme.themeName}`]: {
      display: "flex",
      flexDirection: "column",
    },
    "& .ag-row-disabled": {
      backgroundColor: theme.disabledGridRow,
    },
    "& .ag-theme-material .disabledCheckbox": {
      "& .ag-hidden": {
        display: "block !important",
      },
      "& .ag-icon-checkbox-unchecked": {
        display: "none !important",
      },
      "& .ag-icon-checkbox-indeterminate": {
        display: "none !important",
      },
      "& .ag-icon-checkbox-checked": {
        display: "block !important",
        color: "rgba(0, 0, 0, 0.26)",
      },
      pointerEvents: "none",
    },
    "& .ag-theme-material .disabledCheckboxIBBills": {
        "& .ag-icon-checkbox-checked": {
          color: "rgba(0, 0, 0, 0.26)",
        },
        pointerEvents: "none",
      },
  },
  gridContent: {
    borderColor: theme.AppBGColor,
    borderStyle: "solid",
    borderWidth: "1px",
    boxSizing: "border-box",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    "& .ag-center-cols-viewport": {
      width: `calc(100% + 4px)`,
    }
  },
  pastGridShow: {
    borderTop: `5px solid ${theme.AppBGColor}`,
    minHeight: '40%',
  },
  pastGridHide: {
    display: 'none'
  }
  
});

export default styles;
